import withEditableWidget from '@/components/DashboardPageV2/Desktop/Widgets/Shared/HOC/withEditableWidget'
import { WidgetDefinition } from '@/components/DashboardPageV2/Desktop/Widgets/Shared/utils/WidgetRegistry'
import {
  MeasurementEdit,
  MeasurementView
} from '@/components/DashboardPageV2/Desktop/Widgets/Shared/Measurement'
import { plantScienceTypes } from './types'
import {
  LIVE_QUERY,
  VALUE_CHART
} from '@/components/DashboardPageV2/Desktop/Widgets/Shared/Dynamic/config'
import { defaultQueryOptions } from '../Shared/Dynamic/config/defaults'

const PlantScienceWidget = withEditableWidget(MeasurementView, MeasurementEdit)

class PlantScienceWidgetDefinition extends WidgetDefinition {
  constructor({
    widgetId,
    title,
    icon,
    measurement,
    queryOptionsList = null,
    component = null,
    defaultPosition = null,
    options = null,
    config = null,
    permissionIds = null,
    denyVisibility = null
  }) {
    const defaultPositionDefault = {
      md: [0, 0, 2, 3, 2, 2]
    }
    const configDefault = {
      query: LIVE_QUERY,
      chart: VALUE_CHART,
      range: null,
      interval: null
    }
    const measurementOrError =
      measurement || PlantScienceWidgetDefinition.paramRequired('measurement')

    const optionsDefault = {
      fixedFactor: 1,
      scaleFactor: 1,
      measurement: measurementOrError,
      queryOptionsList: queryOptionsList || defaultQueryOptions
    }

    const superParams = {
      widgetId,
      title,
      icon,
      component: component ?? PlantScienceWidget,
      defaultPosition: defaultPosition ?? defaultPositionDefault,
      config: config ?? configDefault,
      options: options ?? optionsDefault,
      permissionIds: permissionIds,
      visibility: denyVisibility
    }

    if (!superParams.options.queryOptionsList) {
      superParams.options.queryOptionsList = defaultQueryOptions
    }

    super(superParams)
  }

  static paramRequired(param) {
    throw new Error(`PlantScienceWidgetDefinition: ${param} is required.`)
  }
}

export const PlantScienceWidgetDefinitions = () => {
  const types = plantScienceTypes()
  const plantScienceWdigets = Object.keys(types).map(key => {
    return new PlantScienceWidgetDefinition({ ...types[key] })
  })

  return plantScienceWdigets
}
